import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'

import Title from '../../components/Title'
import Select from '../../components/Select'
import Leaf from '../../components/Leaf'
import Button from '../../components/Button'
import ScheduleTable from '../../components/ScheduleTable'
import { getSchoolYears, getTeachersList } from '../../actions/common'
import { getCurrentSchedule, getCurrentScheduleNew, getScheduleWeek } from '../../actions/schedule'
import { getRoomsList } from '../../actions/rooms'
import Input from '../../components/Input'
import moment from 'moment'
import { Checkbox } from '../../components/ModalInputs'

const defaultState = {
    scYear: "0",
    week: "0",
    teacher: '0',
    date: moment().format('YYYY-MM-DD'),
    type: '0'
}

const Schedule = () => {

    const dispatch = useDispatch()
    const { schoolYears, teachers = [] } = useSelector(state => state.common)
    const {
        weeks,
        schedule,
        loading,
        scheduleNew,
        loadingNew
    } = useSelector(state => state.schedule);
    const { list } = useSelector(state => state.rooms);

    const weekNowToPast = [...weeks].reverse()
    const actWeek = weeks.length
        ? weekNowToPast
            ?.[0].week_id
        : '0'

    const [formData,
        setFormData] = useState(defaultState)

    useEffect(() => {
        dispatch(getSchoolYears())
        dispatch(getRoomsList())
        dispatch(getTeachersList())
    }, [])

    useEffect(() => {
        if (formData.scYear == '0') {
            setFormData(prev => ({
                ...prev,
                teacher: '0',
                week: '0',
                scYear: '0'
            }))
            dispatch({ type: 'GET_SCHEDULE_WEEKS_LIST', payload: [] })
            dispatch({ type: 'GET_SCHEDULE_CURRENT', payload: [] })
        }
        if (formData.scYear != '0') {
            dispatch(getScheduleWeek(formData.scYear))
        }

    }, [formData.scYear])

    useEffect(() => {
        if (formData.type === '0') {
            formData.week != '0' && formData.teacher != '0' && dispatch(getCurrentSchedule({ week: formData.week, teacher: formData.teacher }));
        } else if (formData.type == '1' && formData.room !== '0') {
            dispatch(getCurrentScheduleNew({ room: formData.room, date: formData.date }));
        }
    }, [formData.week, formData.teacher, formData.room, formData.date])

    useEffect(() => {
        if (formData.scYear != '0') {
            setFormData(prev => ({
                ...prev,
                teacher: '0',
                week: formData.scYear == '0'
                    ? '0'
                    : actWeek
            }))
        }

    }, [weeks])

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleRefresh = () => {
        if (formData.type === '0') {
            formData.week != '0' && formData.teacher != '0' && dispatch(getCurrentSchedule({ week: formData.week, teacher: formData.teacher }))
        } else if (formData.type == '1' && formData.room !== '0') {
            dispatch(getCurrentScheduleNew({ room: formData.room, date: formData.date }))
        }
    }

    useEffect(() => {
        if (formData?.type === '0') {
            setFormData(prev => ({ ...defaultState }))
        } else {
            setFormData(prev => ({ ...defaultState, type: '1' }))
        }
        dispatch({ type: 'GET_SCHEDULE_CURRENT_NEW', payload: [] })
        dispatch({ type: 'GET_SCHEDULE_CURRENT', payload: [] })
    }, [formData?.type])


    return (<> <Title title="Расписание" />
        <div className={styles.wrapperPanel}>
            <div className={styles.wrapperSelect}>
                {formData.type === '0'
                    ?
                    <> <Select
                        title="Учебный год"
                        name={"scYear"}
                        options={[
                            {
                                name: "Выбрать",
                                value: '0'
                            },
                            ...schoolYears
                        ]}
                        value={formData
                            ?.scYear}
                        withoutArrowMode
                        onChange={handleInputChange} />
                        < Leaf
                            title="Неделя"
                            name={
                                "week"
                            }
                            options={
                                weekNowToPast
                            }
                            setFormData={
                                setFormData
                            }
                            formData={
                                formData
                            } />
                        <Select
                            title="Преподаватель"
                            name={"teacher"}
                            options={[
                                {
                                    name: "Все",
                                    value: '0'
                                },
                                ...teachers.map((el) => ({ name: el.calc_fio, value: el.mid }))
                            ]}
                            value={formData
                                ?.teacher}
                            withoutArrowMode
                            onChange={handleInputChange} />
                    </>
                    :
                    <>
                        {list &&
                            <Select
                                title="Кабинет"
                                name={"room"}
                                options={[
                                    {
                                        name: "Выбрать",
                                        value: '0'
                                    },
                                    ...list?.map((el) => ({ name: el.name, value: el.rid }))]}
                                value={formData?.room}
                                withoutArrowMode
                                onChange={handleInputChange} />
                        }
                        <div className={styles.wrapperDate}>
                            <Input
                                title="Дата"
                                name="date"
                                type="date"
                                value={formData?.date}
                                onChange={handleInputChange} /></div>

                    </>}

                <div className={styles.wrapperCheckbox}>
                    <Checkbox
                        label="По кабинету"
                        name="type"
                        value={formData
                            ?.type}
                        onChange={() => handleInputChange({
                            target: {
                                name: 'type',
                                value: formData?.type == '1' ? '0' : '1'
                            }
                        })} />
                </div>
                <Button onClick={handleRefresh}>Обновить</Button>
            </div>
        </div>

        <div className={styles.wrapperTable}>
            {formData.type == '0' && <ScheduleTable schedule={schedule} loading={loading} />}
            {formData.type == '1' && scheduleNew && <ScheduleTable schedule={scheduleNew} loading={loadingNew} />}
        </div>

        </>)
}

export default Schedule